import React, { useEffect, useState } from "react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { FileDown, Loader2, ClipboardCheck } from "lucide-react";
import { apiClient } from "@/lib/apiClient";
import { toast } from "sonner";

export const AbnahmeReportCard = () => {
  const [meta, setMeta] = useState(null);
  const [downloading, setDownloading] = useState(false);

  useEffect(() => {
    apiClient.get("/admin/abnahme-report/meta").then((r) => setMeta(r.data)).catch(() => setMeta({ available: false }));
  }, []);

  const download = async () => {
    setDownloading(true);
    try {
      const res = await apiClient.get("/admin/abnahme-report", { responseType: "blob" });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = "abnahme_handbuch.md";
      a.click();
      URL.revokeObjectURL(url);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Download fehlgeschlagen");
    } finally {
      setDownloading(false);
    }
  };

  const allGreen = meta?.available && meta.failed === 0;

  return (
    <Card className="p-6" data-testid="abnahme-report-card">
      <div className="flex items-start gap-3">
        <div className={`h-10 w-10 rounded-lg flex items-center justify-center shrink-0 ${allGreen ? "bg-emerald-100 text-emerald-700" : "bg-slate-100 text-slate-700"}`}>
          <ClipboardCheck className="h-5 w-5" />
        </div>
        <div className="flex-1">
          <h3 className="text-base font-semibold text-slate-900">Master-Abnahmetest · Handbuch aller Testabläufe</h3>
          <p className="mt-1 text-sm text-slate-500">
            Eine Markdown-Datei mit Testkatalog, Testdaten, Soll-Berechnungen, erwarteten Buchungen,
            Ist-Werten, Differenzen und Nachweisen für alle Phasen 1–4 (Belege, MWST, Bankabgleich, Buchhaltung &
            Abschluss, Lohn, Anlagen, Reports, Mandantentrennung, Idempotenz, KI-Assistent, Integrationen, Stress-Tests)
            inkl. finanziellem Konsistenzcheck und behobenen Befunden.
          </p>
          {meta?.available && (
            <div className="mt-3 flex flex-wrap gap-2 text-xs" data-testid="abnahme-report-meta">
              <span className={`rounded-full px-2.5 py-1 font-medium ${allGreen ? "bg-emerald-50 text-emerald-800" : "bg-amber-50 text-amber-800"}`}>
                {meta.tests} Tests · {meta.passed} bestanden · {meta.failed} nicht bestanden
              </span>
              <span className="rounded-full bg-slate-100 px-2.5 py-1 text-slate-600">
                Stand {meta.generated_at ? new Date(meta.generated_at).toLocaleString("de-CH") : "–"} · {meta.size_kb} KB
              </span>
            </div>
          )}
          {meta && !meta.available && (
            <p className="mt-3 text-xs text-amber-700" data-testid="abnahme-report-missing">
              Noch kein Handbuch erzeugt – Schlussregression ausführen (<code>python3 -m tests.abnahme.final_report</code>).
            </p>
          )}
          <Button size="sm" className="mt-4" onClick={download} disabled={downloading || !meta?.available} data-testid="abnahme-report-download-button">
            {downloading ? <Loader2 className="h-4 w-4 mr-1.5 animate-spin" /> : <FileDown className="h-4 w-4 mr-1.5" />}
            Abnahme-Handbuch herunterladen (.md)
          </Button>
        </div>
      </div>
    </Card>
  );
};

export default AbnahmeReportCard;
